export default __webpack_public_path__ + "static/media/triangle-vector.780dd15d.svg";